import React from 'react';
import Card from 'components/Card/Card';
import { Icon, Title } from 'ui-library';
import { ICON_EDIT_OUTLINE } from 'ui-library/components/Icon/constants';

// --- Types ---

export interface BundleCardProps {
    productName: string;
    productSubtitle: string;
    documents: string[];
    onEdit: () => void;
}

// --- Component ---

const BundleCard: React.FC<BundleCardProps> = ({
    productName, productSubtitle, documents, onEdit,
}) => {
    const cardTitle = (
        <Title type={3} className="bundled-documents__card-title">
            <span className="bundled-documents__card-title--bold">{productName}</span>
            {' '}
            {productSubtitle}
        </Title>
    );

    const editAction = (
        <Icon
            className="bundled-documents__edit-btn cursor-pointer"
            onClick={onEdit}
            type={ICON_EDIT_OUTLINE}
            size={24}
        />
    );

    return (
        <Card
            className="bundled-documents__card"
            title={cardTitle}
            titleTagName="div"
            headerActions={editAction}
        >
            <ul className="bundled-documents__doc-list">
                {documents.map((doc) => (
                    <li key={doc} className="bundled-documents__doc-item">
                        {doc}
                    </li>
                ))}
            </ul>
        </Card>
    );
};

export default BundleCard;
